import type { StateCreator } from "zustand";
import type { AppStore, State } from "./types";

export const createAppStore: StateCreator<State, [], [], AppStore> = (set) => ({
  shouldBlockNavigation: false,
  setShouldBlockNavigation: (shouldBlock) => {
    set({ shouldBlockNavigation: shouldBlock });
  },
  isMenuOpen: false,
  setIsMenuOpen: (isOpen) => {
    set({ isMenuOpen: isOpen });
  },
  isHomeVisited: false,
  setIsHomeVisited: (isVisited) => {
    set({ isHomeVisited: isVisited });
  },
  pageContextHeader: () => null,
  setPageContextHeader: (header) => {
    set({ pageContextHeader: header });
  },
});
